<div #documentContainer class="document-export-container">
    <!-- Warning Modal -->
    <ng-template #warningModal let-modal>
        <div class="modal-header" style="background-color: transparent;">
            <button type="button" class="close" (click)="modal.dismiss('Close click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="text-align: center;">
            <p class="avertissement m-0" style="padding-bottom: 24px">
                Veuillez sélectionner un contact avant d'ajouter un produit !
            </p>
            <div class="modal-footer m-0 p-0" style="justify-content: center; border-top: none;">
                <button type="button" class="btn btn-primary" (click)="modal.close('OK')" style="padding: 8px 20px">OK</button>
            </div>
        </div>
    </ng-template>

    <!-- Marge Modal (pourcentage + montant TND calculés selon la ligne produit) -->
    <ng-template #margeModal let-modal>
        <div class="modal-header" style="background-color: transparent;">
            <h2 class="sr-only" id="modal-marge-title">Marge</h2>
            <button type="button" class="close" (click)="modal.dismiss('Close click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="text-align: center;">
            <p class="avertissement m-0" style="padding-bottom: 24px">
                <ng-container *ngIf="margeModalPercentDisplay !== null || margeModalMontantDisplay !== null; else margeModalNoData">
                    La marge pour {{ margeModalDesignation }}
                    <ng-container *ngIf="margeModalPercentDisplay !== null">
                        est de {{ margeModalPercentDisplay | number:'1.2-2' }} %
                    </ng-container>
                    <ng-container *ngIf="margeModalPercentDisplay !== null && margeModalMontantDisplay !== null">, </ng-container>
                    <ng-container *ngIf="margeModalMontantDisplay !== null">
                        <ng-container *ngIf="margeModalPercentDisplay === null"> : </ng-container>
                        soit {{ margeModalMontantDisplay | number:'1.3-3' }} TND sur la ligne
                    </ng-container>.
                </ng-container>
                <ng-template #margeModalNoData>
                    <span *ngIf="margeModalDesignation !== '—'">{{ margeModalDesignation }} — </span>
                    <span>Calcul de marge indisponible avec les données actuelles.</span>
                </ng-template>
            </p>
            <div class="modal-footer m-0 p-0" style="justify-content: center; border-top: none;">
                <button type="button" class="btn btn-primary" (click)="modal.close('OK')" style="padding: 8px 20px">OK</button>
            </div>
        </div>
    </ng-template>

    <!-- Depot Warning Modal -->
    <ng-template #depotWarningModal let-modal>
        <div class="modal-header" style="background-color: transparent;">
            <button type="button" class="close" (click)="modal.dismiss('Close click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="text-align: center;">
            <p class="avertissement m-0" style="padding-bottom: 24px">
                Veuillez sélectionner un dépot avant d'ajouter un élément !
            </p>
            <div class="modal-footer m-0 p-0" style="justify-content: center; border-top: none;">
                <button type="button" class="btn btn-primary" (click)="modal.close('OK')" style="padding: 8px 20px">OK</button>
            </div>
        </div>
    </ng-template>

    <!-- Modale rupture de stock (bon livraison, bon réception, inventaire, bon transfert) — maquette centrée -->
    <ng-template #stockRuptureModal let-modal>
        <div class="stock-rupture-alert">
            <h2 class="sr-only" id="modal-stock-rupture-title">Stock insuffisant</h2>
            <button
                type="button"
                class="stock-rupture-alert__close"
                (click)="modal.dismiss('close')"
                aria-label="Fermer"
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="stock-rupture-alert__icon" aria-hidden="true">!</div>
            <div class="stock-rupture-alert__body text-center">
                <ng-container *ngIf="stockRuptureModalLines.length === 1; else stockRuptureMulti">
                    <p class="stock-rupture-alert__title">
                        Stock insuffisant pour le produit
                        <span class="stock-rupture-alert__product-name">{{ stockRuptureModalLines[0].designation }}</span
                        >.
                    </p>
                </ng-container>
                <ng-template #stockRuptureMulti>
                    <p class="stock-rupture-alert__title">
                        Stock insuffisant pour
                        <span class="stock-rupture-alert__product-name">{{ stockRuptureModalLines.length }} produits</span>.
                    </p>
                    <ul class="stock-rupture-alert__product-list list-unstyled mb-2">
                        <li *ngFor="let row of stockRuptureModalLines">{{ row.designation }}</li>
                    </ul>
                </ng-template>
                <p class="stock-rupture-alert__subtitle">Veuillez vérifier la quantité saisie.</p>
            </div>
            <div class="stock-rupture-alert__footer text-center">
                <button type="button" class="stock-rupture-alert__ok" (click)="modal.close('ok')">OK</button>
            </div>
        </div>
    </ng-template>

    <!-- Variantes : même ref. fabricant / fabriquant — maquette Vuexy -->
    <ng-template #variantSelectionModal let-modal>
        <div class="variant-selection-modal">
            <button type="button" class="variant-selection-modal__close" (click)="modal.dismiss('cancel')"
                    aria-label="Fermer">
                <span aria-hidden="true">&times;</span>
            </button>
            <div style="padding: 64px">
            <div class="variant-selection-modal__title-block" >
                <h4 class="variant-selection-modal__title">Variantes de la désignation</h4>
                <p class="variant-selection-modal__subtitle">Veuillez choisir la taille et la couleur de la désignation</p>

            </div>
            <div class="variant-selection-modal__body">
                <div class="variant-selection-modal__product" *ngIf="variantModalPrimary as vp">
                    <div class="variant-selection-modal__product-grid">
                        <span class="variant-selection-modal__label">Désignation</span>
                        <strong class="variant-selection-modal__value">{{ vp.nom }}</strong>
                        <span class="variant-selection-modal__label">Référence</span>
                        <a href="javascript:void(0)" class="variant-selection-modal__ref-link variant-selection-modal__value--link"
                           (click)="openErpProductDetailFromVariantModal(vp.id)">{{ vp.ref_interne || '—' }}</a>
                    </div>
                </div>
                <hr class="variant-selection-modal__divider"/>
                <div class="table-responsive variant-selection-modal__table-wrap">
                    <table class="table variant-selection-modal__table align-middle mb-0">
                        <thead class="variant-selection-modal__thead">
                        <tr class="align-middle">
                            <th class="text-center variant-selection-modal__th-check">
                                <label class="variant-selection-modal__check" title="Tout sélectionner">
                                    <input type="checkbox" class="variant-selection-modal__check-input"
                                           [checked]="areAllVariantModalRowsSelected()"
                                           (change)="toggleAllVariantModalRows($any($event.target).checked)">
                                    <span class="variant-selection-modal__check-ui" aria-hidden="true"></span>
                                </label>
                            </th>
                            <th>CODE À BARRE</th>
                            <th>COULEUR / TAILLE</th>
                            <th>STOCK PHYSIQUE</th>
                            <th>STOCK DISPONIBLE</th>
                            <th class="text-center variant-selection-modal__th-qty">QUANTITÉ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let row of variantModalRows; let ri = index" class="variant-selection-modal__tr">
                            <td class="text-center">
                                <label class="variant-selection-modal__check">
                                    <input type="checkbox" class="variant-selection-modal__check-input"
                                           [(ngModel)]="row.selected" [ngModelOptions]="{standalone: true}">
                                    <span class="variant-selection-modal__check-ui" aria-hidden="true"></span>
                                </label>
                            </td>
                            <td>
                                <a class="variant-selection-modal__ref-link"
                             >
                                    {{ displayCodeBarreVariantFormatted(row.product) }}
                                </a>
                            </td>
                            <td class="variant-selection-modal__cell-couleur">
                                <div class="variant-selection-modal__couleur-l1">{{ formatVariantCouleurOnly(row.product) }}</div>
                                <small class="variant-selection-modal__couleur-l2">{{ formatVariantTailleOnly(row.product) }}</small>
                            </td>
                            <td>
                                <span class="variant-selection-modal__stock-line"
                                      [class.variant-selection-modal__stock-line--ok]="getVariantModalStockDisplay(row.product) > 0"
                                      [class.variant-selection-modal__stock-line--ko]="getVariantModalStockDisplay(row.product) <= 0">
                                    <span class="variant-selection-modal__stock-ring" aria-hidden="true"></span>
                                    <span class="variant-selection-modal__stock-text">{{ getVariantModalStockDisplay(row.product) }} {{ getVariantModalStockStatus(row.product) }}</span>
                                </span>
                            </td>
                            <td>
                                <span class="variant-selection-modal__stock-line"
                                      [class.variant-selection-modal__stock-line--ok]="getVariantStockWebQty(row.product) > 0"
                                      [class.variant-selection-modal__stock-line--ko]="getVariantStockWebQty(row.product) <= 0">
                                    <span class="variant-selection-modal__stock-ring" aria-hidden="true"></span>
                                    <span class="variant-selection-modal__stock-text">{{ getVariantStockWebQty(row.product) }} {{ getVariantStockWebStatus(row.product) }}</span>
                                </span>
                            </td>
                            <td class="text-center variant-selection-modal__qty-cell">
                                <div class="variant-selection-modal__qty-wrap">
                                    <input type="number"
                                           class="form-control input-quantity width-quantity"
                                           [ngModel]="row.quantity"
                                           (ngModelChange)="onVariantModalRowQuantityChange(ri, $event)"
                                           [ngModelOptions]="{standalone: true}"
                                           min="0"
                                           step="1"
                                           style="padding-right: 30px; text-align: center;">
                                    <button type="button" class="button-inc-quantity" (click)="incrementVariantModalQuantity(ri)">
                                        <span data-feather="chevron-up" class="flech"></span>
                                    </button>
                                    <button type="button" class="button-dec-quantity" (click)="decrementVariantModalQuantity(ri)">
                                        <span data-feather="chevron-down"></span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="variant-selection-modal__footer">
                <button type="button" class="btn btn-primary" (click)="confirmVariantSelectionModal(modal)">Confirmer</button>
                <button type="button" class="btn btn-grey" (click)="modal.dismiss('cancel')">Annuler</button>
            </div>
            </div>
        </div>
    </ng-template>

    <!-- Modal référence : préfixe prioritaire depuis GET /api/type-documents/:type_document_id ; format description = modèle référence réécrit avec ce préfixe -->
    <ng-template #referenceModal let-modal>
        <div class="modal-header">
            <h2 class="sr-only" id="modal-reference-title">Référence du document</h2>
            <button type="button" class="close" (click)="modal.dismiss('Close click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group text-center">
                <p class="titre-modal">Ajoutez une référence du document</p>
                <p class="text-muted-gris mb-1">{{ getReferenceModalHelpLine() }}</p>
                <p class="text-muted small mb-0" *ngIf="referenceModelDetail?.description">
                    Format : {{ getReferenceFormatExample() }}
                </p>
                <p class="text-muted small mb-0" *ngIf="!referenceModelDetail?.description">
                    Exemple : {{ getReferencePlaceholder() }}
                </p>
            </div>
            <div class="form-group text-start">
                <label for="documentReference">Référence du document</label>
                <div style="position: relative; flex: 1;">
                    <input
                            type="text"
                            class="input-ref"
                            id="documentReference"
                            [(ngModel)]="documentReference"
                            [placeholder]="getReferenceInputPlaceholder()"
                            #documentInput="ngModel"
                            [class.is-invalid]="documentInput.touched && !isValidNumber(documentInput.value)"
                            (input)="validateInput(documentInput)"
                    />
                    <button type="button" class="button-inc" (click)="increment()">
                        <span data-feather="chevron-up" class="flech"></span>
                    </button>
                    <button type="button" class="button-dec" (click)="decrement()">
                        <span data-feather="chevron-down"></span>
                    </button>
                </div>
                <div *ngIf="documentInput.touched && !isValidNumber(documentInput.value)" class="invalid-feedback d-block">
                    {{ getReferenceValidationMessage() }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-primary"
                    (click)="confirmReference()"
                    style="padding: 10px 20px;"
                    [disabled]="(documentInput.touched && !isValidNumber(documentInput.value)) || isSubmitting"
            >Confirmer</button>
            <button
                    type="button"
                    class="btn"
                    (click)="cancelReference()"
                    style="padding: 10px 20px; background-color: rgba(128, 131, 144, 0.16);"
            >Annuler</button>
        </div>
    </ng-template>

    <app-title-section></app-title-section>
    <app-parametre-bar
        [documentId]="documentId"
            [documentType]="getDocumentType()"
            [initialSettings]="documentColumnSettings"
            [taxStatutDocumentOverrides]="documentTaxStatutOverrides"
            (documentSettingsChange)="onDocumentSettingsChange($event)"
            (taxesUpdated)="onTaxesUpdated()"
            (documentTaxStatutChange)="onDocumentTaxStatutChange($event)">
    </app-parametre-bar>
    <app-ajout-projet
        #ajout
        [clientId]="clientId"
        [stationId]="stationId"
        (projectSaved)="onProjectSaved()">
    </app-ajout-projet>
<app-add-product-modal
    #AddProductModalComponent
    [clientId]="clientId"
    [stationId]="stationId"
    (closeModal)="onProductAdded($event)" >
</app-add-product-modal>
    <app-edit-warehouse
        #editWarehouseModal
        (warehouseSaved)="onWarehouseSaved($event)">
    </app-edit-warehouse>
    <app-add-fourniss
        #ajoutFournisseur
        [clientId]="clientId"
        [stationId]="stationId"
        (fournisseurSaved)="onFournisseurSaved($event)"
    ></app-add-fourniss>
    <app-add-client-modal
        #ajoutClient
        [clientId]="clientId"
        [stationId]="stationId"
        (clientSaved)="onClientSaved($event)">
    </app-add-client-modal>
    <div *ngIf="isLoadingEdit" class="text-center p-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p>Chargement du document...</p>
    </div>
    <div class="global-header bg-white border-bottom rounded p-3" style="margin: 15px 60px 0 10px;">
        <!-- Ligne 1 : logo + œil à gauche / ng-select aligné à droite (même colonne que Client + edit/+) / type document -->
        <div class="d-flex justify-content-between align-items-center document-header-org-row">
            <div class="d-flex align-items-center document-header-logo-group flex-grow-1">
                <div class="document-etab-logo-slot"
                     [class.document-etab-logo--hidden]="!isTitleVisible"
                     [attr.aria-hidden]="!isTitleVisible">
                    <img *ngIf="stationLogo && !documentLogoBroken"
                         [src]="stationLogo"
                         class="logo-img document-etab-logo"
                         alt="Logo établissement"
                         (error)="onDocumentLogoError()">
                    <div *ngIf="!stationLogo || documentLogoBroken"
                         class="document-etab-logo-fallback"
                         [title]="stationName || 'Établissement'"
                         aria-hidden="true">
                        {{ getDocumentLogoInitials() }}
                    </div>
                </div>
                <div style="width: 70%">
                    <button type="button"
                            class="btn-icon-eye document-etab-logo-eye"
                            (click)="toggleTitleVisibility()"
                            [title]="isTitleVisible ? 'Masquer le logo' : 'Afficher le logo'">
                        <span *ngIf="isTitleVisible" class="d-inline-flex align-items-center">
                            <i data-feather="eye" [size]="20" style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </span>
                        <span *ngIf="!isTitleVisible" class="d-inline-flex align-items-center">
                            <i data-feather="eye-off" [size]="20" style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                        </span>
                    </button>
                </div>


                <div
                        *ngIf="mode === 'add' && !isEditing; else documentStationNameOnly"
                        class="document-etab-field ms-auto">
                    <ng-select
                        id="document-etab-select"
                        [items]="orgSelectOptions"
                        bindLabel="label"
                        bindValue="key"
                        [(ngModel)]="selectedOrgKey"
                        [clearable]="false"
                        [searchable]="true"
                        [searchFn]="searchOrgSelectFn"
                        [loading]="loadingEtablissements"
                        [placeholder]="loadingEtablissements ? 'Chargement…' : 'Choisir une station / établissement'"
                        typeToSearchText="Rechercher…"
                        notFoundText="Aucun résultat"
                        (change)="onDocumentOrgSelectChange($event)"
                        appendTo="body"
                        dropdownClass="document-etab-dropdown-panel"
                        class="ng-select-custom text-muted document-etab-ng-select"
                    >
                        <ng-template ng-option-tmp let-opt="item">
                            <div class="option-item d-flex align-items-center justify-content-between w-100">
                                <span class="client-name">{{ opt.label }}</span>
                                <span class="document-etab-type-badge">{{ opt.type === 'station' ? 'Station' : 'Établissement' }}</span>
                            </div>
                        </ng-template>
                        <ng-template ng-label-tmp let-opt="item">
                            <span class="client-name" *ngIf="opt">{{ opt.label }}</span>
                        </ng-template>
                    </ng-select>
                    <p class="document-etab-hint text-muted mb-0" *ngIf="loadingEtablissements">
                        Chargement…
                    </p>
                    <p
                        class="document-etab-hint text-warning mb-0"
                        *ngIf="!loadingEtablissements && !orgSelectOptions.length"
                    >
                        Aucune station / établissement trouvé.
                    </p>
                </div>
                <ng-template #documentStationNameOnly>
                    <p class="m-0 document-etab-name-static ms-auto">{{ stationName }}</p>
                </ng-template>
            </div>

            <p class="document-type-title mb-0">{{ documentType }}</p>
        </div>

        <!-- Ligne 2 : Client ou Fournisseur à gauche / Détails du document à droite -->
        <div class="d-flex justify-content-between align-items-start mt-4 flex-wrap">
            <div class="flex-fill me-4" style="max-width: 45%;" *ngIf="shouldShowClient()">
                <div class="d-flex align-items-center" style="width: 100%;">
                    <p style="font-size: 15px;
              font-weight: 700;
              color: rgba(47, 43, 61, 0.9);">
                        Client
                    </p>

                    <button
                            class="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                            (click)="deselectClient()"
                            style="width: 30px;height: 30px;padding: 0;margin-left: auto;">
                        <i data-feather="edit" class="feather-icon"></i>
                    </button>

                </div>


                <hr class="section-line" style="border-bottom: 1px solid rgba(19, 74, 211, 1)">
                <div class="form-group align-items-center" *ngIf="!selectedClient">
                    <div class="row">
                        <div class="col-12 d-flex align-items-center flex-wrap gap-2 mb-2">
                            <div class="client-search-mode-toggle" role="group" aria-label="Type de client">
                                <button type="button"
                                        class="client-mode-btn"
                                        [class.active]="clientSearchMode === 'patente'"
                                        (click)="setClientSearchMode('patente')">
                                    Professionnel
                                </button>
                                <button type="button"
                                        class="client-mode-btn"
                                        [class.active]="clientSearchMode === 'particulier'"
                                        (click)="setClientSearchMode('particulier')">
                                    Particulier
                                </button>
                            </div>
                        </div>
                        <div class="col-12 d-flex">
                            <ng-select
                                    id="client-select"
                                    [items]="clientsForSelect"
                                    bindLabel="nom_prenom"
                                    bindValue="id"
                                    [(ngModel)]="selectedClientId"
                                    [compareWith]="compareClients"
                                    [clearable]="true"
                                    [searchable]="true"
                                    [searchFn]="searchClients"
                                    [loading]="isLoadingClients"
                                    [placeholder]="clientSearchPlaceholder"
                                    (change)="onClientSelect($event)"
                                    class="ng-select-custom text-muted">

                                <ng-template ng-option-tmp let-client="item">
                                    <div class="option-item d-flex align-items-center">
                                        <span data-feather="user"></span>
                                        <span class="client-name ms-2">{{ getClientSelectLabel(client) }}</span>
                                        <span *ngIf="isCaisseClient(client)" class="badge badge-light-info ms-2">Caisse</span>
                                    </div>
                                </ng-template>

                                <ng-template ng-label-tmp let-client="item">
                                    <div class="d-flex align-items-center">
                                        <span data-feather="user"></span>
                                        <span class="client-name ms-2">{{ getClientSelectLabel(client) }}</span>
                                        <span *ngIf="isCaisseClient(client)" class="badge badge-light-info ms-2">Caisse</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <button type="button" class="add-button ms-2" (click)="openAjoutClientModal()" aria-label="Add new client">
                                <span class="feather-icon" data-feather="plus"></span>
                            </button>
                        </div>


                    </div>
                </div>
                <div *ngIf="selectedClient" class="flex-grow-1">

                    <!-- NOM DU CLIENT -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Nom du Client</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isClientFieldModified('nomClient') ? 'rgba(47, 43, 61, 0.4)' : ''">
            {{ getClientSelectLabel(selectedClient) || selectedClient.nom_prenom || 'Non renseigné' }}
          </span>
                                </td>

                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEdit('nomClient')"
                                            [title]="isClientFieldModified('nomClient') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isClientFieldModified('nomClient')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);" [size]="20"></i>
                                        </span>
                                        <span *ngIf="isClientFieldModified('nomClient')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);" [size]="20"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- IDENTIFIANT UNIQUE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Identifiant unique</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isClientFieldModified('identifiant') ? 'rgba(47, 43, 61, 0.4)' : ''">
            {{ selectedClient.identifiant_unique || 'Non renseigné' }}
          </span>
                                </td>
                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEdit('identifiant')"
                                            [title]="isClientFieldModified('identifiant') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isClientFieldModified('identifiant')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isClientFieldModified('identifiant')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- ADRESSE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Adresse</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isClientFieldModified('adresse') ? 'rgba(47, 43, 61, 0.4)' : ''">
            {{ getAdresseString(selectedClient.adresses) }}
          </span>
                                </td>

                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEdit('adresse')"
                                            [title]="isClientFieldModified('adresse') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isClientFieldModified('adresse')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isClientFieldModified('adresse')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- EMAIL -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Email</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isClientFieldModified('email') ? 'rgba(47, 43, 61, 0.4)' : ''">
            {{ getEmailString(selectedClient.emails) }}
          </span>
                                </td>

                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEdit('email')"
                                            [title]="isClientFieldModified('email') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isClientFieldModified('email')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isClientFieldModified('email')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- NUMERO IDENTIFICATION FISCALE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Numéro d'identification fiscale</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isClientFieldModified('numeroIdentification') ? 'rgba(47, 43, 61, 0.4)' : ''">
                                        {{ selectedClient.numero_identification_fiscale || 'Non renseigné' }}
                                    </span>
                                </td>
                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEdit('numeroIdentification')"
                                            [title]="isClientFieldModified('numeroIdentification') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isClientFieldModified('numeroIdentification')" class="d-inline-flex">
                                            <i data-feather="eye" [size]="20" style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isClientFieldModified('numeroIdentification')" class="d-inline-flex">
                                            <i data-feather="eye-off" [size]="20" style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                </div>
            </div>

            <div class="flex-fill me-4" style="max-width: 45%;" *ngIf="shouldShowFournisseur()">
                <div class="d-flex align-items-center" style="width: 100%;">
                <p style="font-size: 15px; font-weight: 700; color: rgba(47, 43, 61, 0.9);">Fournisseur</p>
                    <button
                            class="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                            (click)="deselectFournisseur()"
                            style="width: 30px;height: 30px;padding: 0;margin-left: auto;">
                        <i data-feather="edit" class="feather-icon"></i>
                    </button>
                </div>
                <hr class="section-line" style="border-bottom: 1px solid rgba(19, 74, 211, 1)">
                <div class="form-group align-items-center" *ngIf="!selectedFournisseur">
                    <div class="row">
                        <div class="col-12">
                            <label for="fournisseur-select">Fournisseur</label>
                        </div>
                        <div class="col-12 d-flex">
                            <ng-select
                                    *ngIf="['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(documentType)"
                                    #fournisseurSelect
                                    id="fournisseur-select"
                                    [items]="fournisseurs"
                                    bindLabel="nom_entreprise"
                                    bindValue="id"
                            [(ngModel)]="selectedFournisseurId"
                            [compareWith]="compareFournisseurs"
                            [clearable]="true"
                            [searchable]="true"
                            [loading]="isLoadingFournisseurs"
                            class="ng-select-custom text-muted"
                            placeholder="Choisissez un fournisseur"
                            (change)="onFournisseurSelect($event)"
                            [disabled]="isLoadingEdit || mode === 'validation'"
                            >
                                <ng-template ng-option-tmp let-fournisseur="item">
                                    <div class="option-item d-flex align-items-center">
                                        <span data-feather="user"></span>
                                        <span class="client-name ms-2">{{ fournisseur.nom_entreprise }}</span>
                                    </div>
                                </ng-template>
                                <ng-template ng-label-tmp let-fournisseur="item">
                                    <div class="d-flex align-items-center">
                                        <span data-feather="user"></span>
                                        <span class="client-name ms-2">{{ fournisseur.nom_entreprise }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <button type="button" class="add-button ms-2" (click)="openAjoutFournisseurModal()" aria-label="Add new supplier">
                                <span class="feather-icon" data-feather="plus"></span>
                            </button>
                        </div>
                        <div *ngIf="isLoadingFournisseurs" class="text-muted" style="font-size: 12px;">
                            Chargement des fournisseurs...
                        </div>
                        <div *ngIf="fournisseurs.length === 0 && !isLoadingFournisseurs" class="text-muted" style="font-size: 12px;">
                            Aucun fournisseur actif disponible.
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedFournisseur" class="flex-grow-1">
                    <!-- NOM ENTREPRISE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Nom de l'entreprise</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isFournisseurFieldModified('nomEntreprise') ? 'rgba(47, 43, 61, 0.4)' : ''">
                                        {{ selectedFournisseur.nom_entreprise || 'Non renseigné' }}
                                    </span>
                                </td>


                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEditFournisseur('nomEntreprise', $event)"
                                            [title]="isFournisseurFieldModified('nomEntreprise') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isFournisseurFieldModified('nomEntreprise')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isFournisseurFieldModified('nomEntreprise')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- NUMERO IDENTIFICATION FISCALE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Numéro identification fiscale</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isFournisseurFieldModified('numeroIdentification') ? 'rgba(47, 43, 61, 0.4)' : ''">
                                        {{ selectedFournisseur.numero_identification_fiscale || 'Non renseigné' }}
                                    </span>
                                </td>
                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEditFournisseur('numeroIdentification', $event)"
                                            [title]="isFournisseurFieldModified('numeroIdentification') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isFournisseurFieldModified('numeroIdentification')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isFournisseurFieldModified('numeroIdentification')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- RESPONSABLE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Responsable</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isFournisseurFieldModified('responsable') ? 'rgba(47, 43, 61, 0.4)' : ''">
                                        {{ getResponsableFournisseur(selectedFournisseur) }}
                                    </span>
                                </td>

                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEditFournisseur('responsable', $event)"
                                            [title]="isFournisseurFieldModified('responsable') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isFournisseurFieldModified('responsable')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isFournisseurFieldModified('responsable')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- PHONE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Téléphone</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isFournisseurFieldModified('telephone') ? 'rgba(47, 43, 61, 0.7)' : ''">
                                        {{ getTelephoneString(selectedFournisseur.telephones) }}
                                    </span>
                                </td>

                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEditFournisseur('telephone', $event)"
                                            [title]="isFournisseurFieldModified('telephone') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isFournisseurFieldModified('telephone')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isFournisseurFieldModified('telephone')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr>

                    <!-- ADRESSE -->
                    <div class="mb-2">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td class="size15" style="width: 250px; vertical-align: middle;">Adresse</td>
                                <td class="size15-400" style="width: 480px; vertical-align: middle;">
                                    <span [style.color]="isFournisseurFieldModified('adresse') ? 'rgba(47, 43, 61, 0.7)' : ''">
                                        {{ getAdresseString(selectedFournisseur.adresses) }}
                                    </span>
                                </td>


                                <td class="text-end" style="width: 30px; padding-right: 0; vertical-align: middle;">
                                    <button type="button" class="btn-icon-eye"
                                            (click)="toggleEditFournisseur('adresse', $event)"
                                            [title]="isFournisseurFieldModified('adresse') ? 'Réactiver l\'affichage du champ' : 'Désactiver l\'affichage (grisé)'">
                                        <span *ngIf="!isFournisseurFieldModified('adresse')" class="d-inline-flex">
                                            <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                        <span *ngIf="isFournisseurFieldModified('adresse')" class="d-inline-flex">
                                            <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: 20px; color: rgba(47, 43, 61, 0.9);"></i>
                                        </span>
                                    </button>
                                </td>

                            </tr>
                        </table>
                    </div>
                    <hr>
                </div>
            </div>

            <div class="flex-fill" [class.ml-auto]="shouldAlignDetailsRight()" style="max-width: 45%;">
                <p style="font-size: 15px; font-weight: 700;color: rgba(47, 43, 61, 0.9);">Détails du document</p>
                <hr class="section-line" style="border-bottom: 1px solid rgba(19, 74, 211, 1)">
                <div class="form-group align-items-center" *ngIf="isDateVisible && ( documentType === 'BON RECEPTION' || documentType === 'FACTURE FOURNISSEUR')">
                    <div class="row">
                        <div class="col-12">
                            <label>Référence externe</label>
                        </div>
                        <div class="col-12 d-flex align-items-center" style="padding-bottom: 24px">
                            <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="refExterne"
                                    [disabled]="isReferenceReadonly"

                            />
                            <button type="button" class="btn-icon-eye" (click)="toggleReadonly('refExterne')" btn-icon-eye
                                    [title]="isReferenceReadonly ? 'Activer la saisie' : 'Désactiver la saisie'">
                                <span *ngIf="!isReferenceReadonly" class="d-inline-flex align-items-center" style="margin-left: 8px">
                                    <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                                <span *ngIf="isReferenceReadonly" class="d-inline-flex align-items-center" style="margin-left: 8px">
                                    <i data-feather="eye-off"  [size]="20"  style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group align-items-center">
                    <div class="row">
                        <div class="col-12">
                            <label>Date</label>
                        </div>
                        <div class="col-12 d-flex align-items-center" style="padding-bottom: 24px">
                            <ng2-flatpickr
                                    #documentDateFlatpickr
                                    name="basicDate"
                                    [config]="basicDateOptions"
                                    [(ngModel)]="documentDate"
                                    style="width: 100%;"
                            ></ng2-flatpickr>
                            <button type="button" class="btn-icon-eye" (click)="toggleReadonly('date')" btn-icon-eye
                                    [title]="isDateReadonly ? 'Activer la saisie' : 'Désactiver la saisie'">
                                <span *ngIf="!isDateReadonly" class="d-inline-flex align-items-center" style="margin-left: 8px">
                                    <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                                <span *ngIf="isDateReadonly" class="d-inline-flex align-items-center" style="margin-left: 8px">
                                    <i data-feather="eye-off"  [size]="20"  style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Entrepôt unique pour les autres types -->
                <div class="form-group align-items-center" *ngIf="isEntrepotVisible && documentType !== 'BON TRANSFERT' && (documentType === 'BON RECEPTION' || documentType === 'FACTURE FOURNISSEUR' || documentType === 'FACTURE' || documentType === 'BON DE LIVRAISON' || documentType === 'INVENTAIRE')">
                    <div class="row">
                        <div class="col-12">
                            <label class="me-2">Entrepot</label>
                        </div>
                        <div class="col-12 d-flex align-items-center" style="padding-bottom: 24px">

                            <ng-select
                                    [(ngModel)]="selectedWarehouseId"
                                    [items]="warehouses"
                                    bindLabel="nom"
                                    bindValue="id"
                                    (change)="reloadStockQuantitiesForAllProducts()"
                                    [disabled]="isEntrepotReadonly"
                                    placeholder="Choisissez un entrepôt"
                                    [searchable]="true"
                                    [clearable]="true"
                                    [loading]="isLoadingWarehouses"
                                    class="project-select flex-grow-1"
                                    appendTo="body"
                                    #warehouseSelect="ngModel"
                                    name="warehouse"
                                    id="warehouse"
                                    (change)="onWarehouseChange()">

                                <!-- Option vide -->
                                <ng-option [value]="null" disabled>Choisissez un entrepôt</ng-option>

                                <!-- Template personnalisé (optionnel mais joli) -->
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="d-flex flex-column">
                                        <strong>{{ item.nom }}</strong>
                                        <small class="text-muted">{{ item.ville }} • {{ item.adresse }}</small>
                                    </div>
                                </ng-template>
                            </ng-select>

                            <!-- Bouton + pour ajouter -->
                            <button type="button"
                                    class="add-button ms-2"
                                    (click)="openAddWarehouseModal('single')"
                                    title="Ajouter un nouvel entrepôt">
                                <span data-feather="plus"></span>
                            </button>

                            <!-- Bouton œil (tu gardes ton toggle existant) -->
                            <button type="button" class="btn-icon-eye" (click)="toggleReadonly('entrepot')" style="margin: 0 0 0 8px"
                                    [title]="isEntrepotReadonly ? 'Activer la sélection' : 'Désactiver la sélection'">
                                <span *ngIf="!isEntrepotReadonly" class="d-inline-flex">
                                    <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                                <span *ngIf="isEntrepotReadonly" class="d-inline-flex">
                                    <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                            </button>


                        </div>
                    </div>
                </div>

                <!-- Deux entrepôts pour BON TRANSFERT -->
                <div class="form-group align-items-center" *ngIf="documentType === 'BON TRANSFERT'">
                    <div class="row">
                        <!-- Entrepôt Initial -->
                        <div class="col-12" style="margin-bottom: 24px">
                            <label class="me-2">Entrepôt Initial</label>
                            <div class="d-flex align-items-center" style="padding-bottom: 12px">
                                <ng-select
                                        [(ngModel)]="selectedWarehouseInitialId"
                                        [items]="warehouses"
                                        bindLabel="nom"
                                        bindValue="id"
                                        [disabled]="isEntrepotReadonly || isEntrepotInitialReadonly"
                                        placeholder="Choisissez l'entrepôt initial"
                                        [searchable]="true"
                                        [clearable]="true"
                                        [loading]="isLoadingWarehouses"
                                        class="project-select flex-grow-1"
                                        appendTo="body"
                                        name="warehouseInitial"
                                        id="warehouseInitial"
                                        (change)="onWarehouseChange()">
                                    <ng-option [value]="null" disabled>Choisissez l'entrepôt initial</ng-option>
                                    <ng-template ng-option-tmp let-item="item">
                                        <div class="d-flex flex-column">
                                            <strong>{{ item.nom }}</strong>
                                            <small class="text-muted">{{ item.ville }} • {{ item.adresse }}</small>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <button type="button"
                                        class="add-button ms-2"
                                        (click)="openAddWarehouseModal('initial')"
                                        title="Ajouter un nouvel entrepôt">
                                    <span data-feather="plus"></span>
                                </button>
                                <button type="button" class="btn-icon-eye" (click)="toggleReadonly('entrepotInitial')" style="margin: 0 0 0 8px" [title]="isEntrepotInitialReadonly ? 'Activer la sélection' : 'Désactiver la sélection'">
                                    <span *ngIf="!isEntrepotInitialReadonly" class="d-inline-flex">
                                        <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                    </span>
                                    <span *ngIf="isEntrepotInitialReadonly" class="d-inline-flex">
                                        <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                    </span>
                                </button>
                            </div>
                        </div>

                        <!-- Entrepôt Destination -->
                        <div class="col-12">
                            <label class="me-2">Entrepôt Destination</label>
                            <div class="d-flex align-items-center" style="padding-bottom: 24px">
                                <ng-select
                                        [(ngModel)]="selectedWarehouseDestinationId"
                                        [items]="warehouses"
                                        bindLabel="nom"
                                        bindValue="id"
                                        [disabled]="isEntrepotReadonly || isEntrepotDestinationReadonly"
                                        placeholder="Choisissez l'entrepôt destination"
                                        [searchable]="true"
                                        [clearable]="true"
                                        [loading]="isLoadingWarehouses"
                                        class="project-select flex-grow-1"
                                        appendTo="body"
                                        name="warehouseDestination"
                                        id="warehouseDestination"
                                        (change)="onWarehouseChange()">
                                    <ng-option [value]="null" disabled>Choisissez l'entrepôt destination</ng-option>
                                    <ng-template ng-option-tmp let-item="item">
                                        <div class="d-flex flex-column">
                                            <strong>{{ item.nom }}</strong>
                                            <small class="text-muted">{{ item.ville }} • {{ item.adresse }}</small>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <button type="button"
                                        class="add-button ms-2"
                                        (click)="openAddWarehouseModal('destination')"
                                        title="Ajouter un nouvel entrepôt">
                                    <span data-feather="plus"></span>
                                </button>
                                <button type="button" class="btn-icon-eye" (click)="toggleReadonly('entrepotDestination')" style="margin: 0 0 0 8px" [title]="isEntrepotDestinationReadonly ? 'Activer la sélection' : 'Désactiver la sélection'">
                                    <span *ngIf="!isEntrepotDestinationReadonly" class="d-inline-flex">
                                        <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                    </span>
                                    <span *ngIf="isEntrepotDestinationReadonly" class="d-inline-flex">
                                        <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group align-items-center" *ngIf="isDateVisible && (documentType === 'COMMANDE FOURNISSEUR' || documentType === 'COMMANDE CLIENT') && documentColumnSettings.afficherDateLivraison">
                    <div class="row">
                        <div class="col-12">
                            <label>Date de livraison</label>
                        </div>
                        <div class="col-12 d-flex align-items-center" style="padding-bottom: 24px">
                            <ng2-flatpickr
                                    #dateLivraisonFlatpickr
                                    name="dateLivraison"
                                    [config]="basicDateLivraisonOptions"
                                    [(ngModel)]="dateLivraison"
                                    style="width: 100%;">
                            </ng2-flatpickr>
                            <button type="button" class="btn-icon-eye" (click)="toggleReadonly('dateLiv')" btn-icon-eye
                                    [title]="isDateLivReadonly ? 'Activer la saisie' : 'Désactiver la saisie'">
                                <span *ngIf="!isDateLivReadonly" class="d-inline-flex align-items-center" style="margin-left: 8px">
                                    <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                                <span *ngIf="isDateLivReadonly" class="d-inline-flex align-items-center" style="margin-left: 8px">
                                    <i data-feather="eye-off"  [size]="20"  style="width: 20px;height: auto;color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group align-items-center" *ngIf="isProjectVisible">
                    <div class="row">
                        <div class="col-12">
                            <label class="me-2">Projet</label>
                        </div>
                        <div class="col-12 d-flex align-items-center" style="padding-bottom: 12px">
                            <ng-select
                                    [(ngModel)]="selectedProject"
                                    (ngModelChange)="onProjectSelect($event)"
                                    [items]="projects"
                                    bindLabel="libelle"
                                    bindValue="libelle"
                                    placeholder="Choisissez un projet"
                                    class="project-select"
                                    [disabled]="isProjectReadonly"
                                    [loading]="isLoadingProjects"
                                    style="width: 100%"
                                    [searchable]="true"
                                    [clearable]="true">
                            </ng-select>
                            <button type="button"
                                    class="add-button ms-2"
                                    (click)="$event.stopPropagation(); ajout.openModal()"
                                    title="Ajouter un nouveau projet">
                                <span data-feather="plus"></span>
                            </button>
                            <button type="button" class="btn-icon-eye" (click)="toggleReadonly('project')" style="margin: 0 0 0 8px"
                                    [title]="isProjectReadonly ? 'Activer la sélection' : 'Désactiver la sélection'">
                                <span *ngIf="!isProjectReadonly" class="d-inline-flex">
                                    <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                                <span *ngIf="isProjectReadonly" class="d-inline-flex">
                                    <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                            </button>
                        </div>
                        <div *ngIf="projects.length === 0 && !isLoadingProjects" class="text-muted" style="font-size: 12px;">
                            Aucun projet disponible.
                        </div>
                        <div *ngIf="isLoadingProjects" class="text-muted" style="font-size: 12px;">
                            Chargement des projets...
                        </div>
                    </div>
                </div>
                <div class="form-group align-items-center" *ngIf="isCategorieVisible && documentType === 'FACTURE FOURNISSEUR'">
                    <div class="row">
                        <div class="col-12">
                            <label class="me-2">Catégorie</label>
                        </div>
                        <div class="col-12 d-flex align-items-center" style="padding-bottom: 12px;width: 723px">
                            <ng-select
                                    [(ngModel)]="selectedCategorie"
                                    (ngModelChange)="onCategorieSelect($event)"
                                    [items]="categories"
                                    bindLabel="libelle"
                                    bindValue="libelle"
                                    style="width: 723px"
                                    placeholder="Choisissez une catégorie"
                                    class="category-select"
                                    [disabled]="isCategorieReadonly"
                                    [loading]="isLoadingCategories"
                                    [searchable]="true"
                                    [clearable]="true"
                            >
                            </ng-select>
                            <button type="button" class="btn-icon-eye" (click)="toggleReadonly('categorie')" style="margin: 0 0 0 8px"
                                    [title]="isCategorieReadonly ? 'Activer la sélection' : 'Désactiver la sélection'">
                                <span *ngIf="!isCategorieReadonly" class="d-inline-flex">
                                    <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                                <span *ngIf="isCategorieReadonly" class="d-inline-flex">
                                    <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                                </span>
                            </button>
                            <small *ngIf="isLoadingCategories" class="form-text text-muted ms-2">Chargement des catégories...</small>
                        </div>
                    </div>
                </div>

                <div class="form-group" *ngIf="isNoteVisible">
                    <label class="form-label">Note</label>
                    <div class="d-flex align-items-center">
                        <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="note"
                                [disabled]="isNoteReadonly"
                        />
                        <button type="button" class="btn-icon-eye" (click)="toggleReadonly('note')" style="margin: 0 0 0 8px"
                                [title]="isNoteReadonly ? 'Activer la saisie' : 'Désactiver la saisie'">
                            <span *ngIf="!isNoteReadonly" class="d-inline-flex">
                                <i data-feather="eye"  [size]="20"  [size]="20"style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                            </span>
                            <span *ngIf="isNoteReadonly" class="d-inline-flex">
                                <i data-feather="eye-off"  [size]="20"  style="width: 20px; height: auto; color: rgba(47, 43, 61, 0.9);"></i>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="form-group" *ngFor="let field of customFields; let i = index">
                    <div class="items2" style="padding-top: 24px">
                        <div class="mr-1" style="width: 30%">
                            <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="field.label"
                                    placeholder="Nom du champ (ex: Référence, Numéro série...)"
                            />
                        </div>
                        <div style="width: 100%;">
                            <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="field.value"
                                    placeholder="Entrer {{ field.label || 'valeur' }}"
                            />
                        </div>
                        <button class="unstyled-btn btn-icon-eye" (click)="removeField(i)" style="margin: 0 0 0 8px">
                            <i data-feather="trash-2" [size]="22" class="text-danger cursor-pointer"></i>
                        </button>
                    </div>
                </div>
                <div style="padding: 24px 0 24px 0">
                    <button class="btn btn-primary" (click)="addField()"><p style="margin: 4px 20px;">Ajouter Un Champ</p></button>
                </div>
            </div>
        </div>

        <div class="products-section">
            <table class="products-table table-bordered p-0 m-0">
                <thead>
                <tr>
                    <th *ngIf="documentColumnSettings.reference" class="document-th-code-barre"
                        style="min-width: 200px;width: 270px;text-transform: uppercase;">
                        <span class="document-th-code-barre__inner">
                            <img [src]="barcodeColumnIconUrl" alt="" class="document-th-code-barre__icon" width="18" height="18">
                            <span>Code à barre</span>
                        </span>
                    </th>
                    <th style="text-transform: uppercase;">DÉSIGNATION / référence</th>
                    <!-- Colonne Quantité disponible : BL, BR, inventaire, bon transfert -->
                    <th *ngIf="showQuantiteDisponibleColumn()" style="width: 150px;min-width: 150px;max-width: 200px">Quantité disponible</th>
                    <th *ngIf="documentColumnSettings.quantite" style="width: 100px;min-width: 120px;max-width: 200px">Quantité</th>
                    <th *ngIf="documentColumnSettings.unite">Unité</th>
                    <!-- Valeur unitaire pour inventaire, bon-transfert et facture fournisseur ; Prix HT pour les autres -->
                    <th *ngIf="documentColumnSettings.prixUnitaire" style="width: 150px;max-width: 200px;min-width: 120px">
                        <span *ngIf="documentType === 'INVENTAIRE' || documentType === 'BON TRANSFERT'">Valeur unitaire</span>
                        <span *ngIf="documentType === 'FACTURE FOURNISSEUR'">Prix d'achat / Valeur unitaire</span>
                        <span *ngIf="documentType !== 'INVENTAIRE' && documentType !== 'BON TRANSFERT' && documentType !== 'FACTURE FOURNISSEUR'">Prix HT</span>
                    </th>
                    <th *ngIf="documentColumnSettings.remise" style="min-width: 80px;width: 100px">Remise</th>
                    <th *ngIf="documentColumnSettings.tva" style="min-width: 100px;width: 140px;max-width: 200px">TVA</th>
                    <th *ngIf="documentColumnSettings.afficherMontantsTTC && (documentType !== 'INVENTAIRE' && documentType !== 'BON TRANSFERT')" style="width: 180px;max-width: 300px">
                        Montant TTC
                    </th>
                    <th style="width: 180px;max-width: 300px">TOTAL HT</th>
                    <th class="position-sticky end-0 text-center shadow-sm" style="min-width: 100px;width: 140px;"
                      >
                        <small class="text-muted"></small>
                    </th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let item of items; let i = index">
                    <ng-container [ngSwitch]="item.type">

                        <!-- PRODUIT -->
                        <ng-container *ngSwitchCase="'product'">
                            <tr 
                                draggable="true"
                                (dragstart)="onDragStart($event, i)"
                                (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event, i)"
                                (drop)="onDrop($event, i)"
                                (dragenter)="onDragEnter($event)"
                                [class.dragging]="draggedIndex === i"
                                style="cursor: move;">
                                <td *ngIf="documentColumnSettings.reference" class="table-input document-td-code-barre">
                                    <div class="document-barcode-picker-wrap">
                                        <button type="button"
                                                class="document-barcode-picker-wrap__edit-overlay"
                                                *ngIf="item.type === 'product' && item.designation?.trim() && !barcodePickerUnlockEdit[i]"
                                                (click)="enableBarcodePickerEdit(i)"
                                                title="Cliquer pour modifier le code à barre">
                                        </button>
                                        <ng-select
                                                class="document-barcode-ng-select"
                                                [class.document-barcode-ng-select--filled]="!!item.designation?.trim()"
                                                [items]="getBarcodePickerItemsForLine(i)"
                                                bindLabel="code_barre"
                                                [compareWith]="compareBarcodePickerProduct"
                                                [searchFn]="searchBarcodePickerFn"
                                                [trackByFn]="trackBarcodePickerById"
                                                [(ngModel)]="barcodePickerModel[i]"
                                                [ngModelOptions]="{standalone: true, updateOn: 'change'}"
                                                (search)="onBarcodePickerSearch(i, $event)"
                                                (change)="onBarcodeColumnSelect(i, $event)"
                                                [readonly]="!!item.designation?.trim() && !barcodePickerUnlockEdit[i]"
                                                [clearable]="false"
                                                [searchable]="!item.designation?.trim() || barcodePickerUnlockEdit[i]"
                                                [loading]="(!item.designation?.trim() || barcodePickerUnlockEdit[i]) && (isLoadingProducts || isProductLineBarcodeSearchLoading(i))"
                                                [disabled]="isLoadingProducts"
                                                [closeOnSelect]="true"
                                                placeholder="Cherchez un code à barre"
                                                notFoundText="Aucun code à barre"
                                        >
                                            <ng-template ng-option-tmp let-item="item">
                                                <div class="document-barcode-option">
                                                    <div class="document-barcode-option__code">
                                                        {{ formatBarcodeDisplayForPicker(item.code_barre ?? item.code_bar) }}
                                                    </div>
                                                    <div class="document-barcode-option__attrs">
                                                        {{ formatBarcodePickerCouleurTaille(item) }}
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <ng-template ng-label-tmp let-item="item">
                                                <span class="document-barcode-option__code document-barcode-option__code--label">
                                                    {{ formatBarcodeDisplayForPicker(item.code_barre ?? item.code_bar) }}
                                                </span>
                                            </ng-template>
                                        </ng-select>
                                        <img [src]="barcodeColumnIconUrl" alt="" class="document-barcode-picker-wrap__icon" width="18" height="18">
                                    </div>
                                </td>
                                <td class="table-input" style="width: auto">
                                    <div class="d-flex">
                                        <ng-select
                                                [items]="getProductSelectItemsForLine(i)"
                                                bindLabel="nom"
                                                bindValue="nom"
                                                [(ngModel)]="item.designation"
                                                [ngModelOptions]="{standalone: true, updateOn: 'change'}"
                                                (change)="onProductSelect(i, $event)"
                                                [clearable]="true"
                                                [searchable]="true"
                                                [loading]="isLoadingProducts || isProductLineBarcodeSearchLoading(i)"
                                                appendTo="body"
                                                dropdownPosition="auto"
                                                class="ng-select-custom product-select document-designation-ng-select"
                                                style="max-width: auto; width: 100%;min-width: 380px"
                                                placeholder="Sélectionnez la désignation"
                                                [disabled]="isLoadingProducts"
                                        >
                                            <ng-template ng-option-tmp let-item="item">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <!-- IMAGE OU ICÔNE PAR DÉFAUT -->
                                                        <div class="logo-product-wrapper me-3">
                                                            <img
                                                                    [src]="item.image"
                                                                    class="logo-product"
                                                                    [class.d-none]="!item.image"

                                                                    alt="{{ item.nom }}">

                                                            <!-- Icône par défaut si pas d'image -->
                                                            <i class="bi bi-box-seam text-muted fs-4"
                                                               [class.d-none]="item.image"></i>
                                                        </div>

                                                        <div class="d-flex flex-column product-select__designation-col">
                                                            <span class="product-name">{{ item.nom }}</span>
                                                            <small class=" product-select__ref-interne">{{ item.ref_interne || item.reference || '—' }}</small>
                                                        </div>
                                                    </div>
                                                    <span
                                                            class="badge"
                                                            [ngClass]="{
                                                    'badge-en-stok': getSelectOptionTotalStockDisplay(item) > 0,
                                                    'badge-tous': getSelectOptionTotalStockDisplay(item) <= 0
                                                  }">
                                                  {{ getSelectOptionTotalStockDisplay(item) }} : {{ getSelectOptionStockStatus(item) }}
                                                </span>
                                                </div>
                                            </ng-template>
                                            <ng-template ng-label-tmp let-item="item">
                                                <div *ngIf="item && item.nom; else placeholder"
                                                     class="product-select__label-selected product-select__nom-ref-line text-start"
                                                     data-debug="selected-{{item.nom}}">
                                                    <span class="product-select__label-nom">{{ item.nom }}</span><span class="text-muted product-select__nom-ref-sep"> / </span><span class="text-muted product-select__ref-suffix">{{ item.ref_interne || item.reference || '—' }}</span>
                                                </div>
                                                <ng-container #placeholder *ngIf="!item || !item.nom">
                                                    <span class="ng-placeholder" data-debug="placeholder" style="display: block; text-align: center;">Sélectionnez la désignation</span>
                                                </ng-container>
                                            </ng-template>


                                        </ng-select>
                                        <button type="button"
                                                class="add-button ms-2"
                                                (click)="openAddProduct()"
                                                *ngIf="(!item.designation || item.designation.trim() === '') && item.type === 'product'"
                                                title="Ajouter un nouvel entrepôt">
                                            <span data-feather="plus"></span>
                                        </button>
                                    </div>

                                    <div class="taxes-radio" *ngIf="item.product_id && item['taxesProduit']?.length >= 0">

                                        <!-- Ligne fixe pour taxes et checkbox Description -->
                                        <div style="display: flex; align-items: flex-start; align-content: start; gap: 12px; flex-wrap: nowrap;margin-top: 12px">
                                            <!-- Checkbox Description avec le même style que les taxes -->
                                            <div class="form-check form-check-inline" style="margin-right: 22px;">
                                                <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        [id]="'description-'+i"
                                                        [checked]="showProductDescription[i]"
                                                        (change)="toggleProductDescription(i)"
                                                >
                                                <label class="form-check-label small fw-medium mb-0" [for]="'description-'+i">
                                                    Description
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline check-border" *ngFor="let taxe of getActiveTaxesForProduct(item)" style="margin: 0;">
                                                <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        [id]="'taxe-'+i+'-'+taxe.id"
                                                        [checked]="isTaxeAssignedToProduct(item, taxe)"
                                                        (change)="toggleTaxeForLine(i, taxe)"
                                                >
                                                <label class="form-check-label small fw-medium" [for]="'taxe-'+i+'-'+taxe.id">
                                                    {{ taxe.nom || taxe.label }} ({{ taxe.valeur }})
                                                    <!--<span class="badge bg-success text-white ms-1" *ngIf="taxe.applique_avant_tva">Avant TVA</span>
                                                    <span class="badge bg-info text-white ms-1" *ngIf="taxe.applique_apres_tva">Après TVA</span>
                                                    -->
                                                </label>
                                            </div>


                                        </div>

                                        <!-- Zone de texte pour la description du produit sous la ligne des taxes/checkbox -->
                                        <div *ngIf="showProductDescription[i]" style="margin-top: 12px; display: flex; flex-direction: column;">
                                            <label class="form-label small text-muted mb-1">Description du produit:</label>
                                            <textarea
                                                    class="form-control"
                                                    rows="3"
                                                    [value]="productDescriptions[i] || ''"
                                                    (input)="productDescriptions[i] = $any($event.target).value"
                                                    [placeholder]="(productDescriptions[i] && productDescriptions[i].trim()) ? 'Description du produit...' : 'Aucune description disponible...'"
                                                    style="font-size: 14px; resize: vertical; min-height: 80px; width: 100%;">
                                            </textarea>
                                        </div>
                                        </div>


                                </td>

                                <!-- Colonne Quantité disponible : BL, BR, inventaire, bon transfert -->
                                <td *ngIf="showQuantiteDisponibleColumn()" class="table-input text-center" style="max-width: 200px !important;">
                                    <span *ngIf="item.designation && item.product_id">
                                        <span *ngIf="item.stockResolved === true" class="fw-bold" [ngClass]="{
                                            'text-success': getStockQuantityForDisplay(item) > 0,
                                            'text-danger': getStockQuantityForDisplay(item) <= 0
                                        }">
                                            {{ getStockQuantityForDisplay(item) }}
                                        </span>
                                        <span *ngIf="item.stockResolved !== true" class="text-muted small">…</span>
                                    </span>
                                    <span *ngIf="item.designation && !item.product_id" class="text-muted">--</span>
                                </td>

                                <td *ngIf="documentColumnSettings.quantite" class="table-input text-center" style="max-width: 150px !important;">
                                    <div *ngIf="item.designation" style="position: relative; display: inline-block; width: 100%; max-width: 110px;">
                                        <input 
                                            type="number" 
                                            class="form-control input-quantity" 
                                            [(ngModel)]="item.quantity" 
                                            (input)="calculateTotal(i)"
                                            style="padding-right: 30px; text-align: center;">
                                        <button type="button" class="button-inc-quantity" (click)="incrementQuantity(i)">
                                            <span data-feather="chevron-up" class="flech"></span>
                                        </button>
                                        <button type="button" class="button-dec-quantity" (click)="decrementQuantity(i)">
                                            <span data-feather="chevron-down"></span>
                                        </button>
                                    </div>
                                </td>

                                <td *ngIf="documentColumnSettings.unite" class="text-center table-input">
                                    <strong *ngIf="item.designation">{{ getUniteLibelle(item) }}</strong>
                                </td>

                                <td *ngIf="documentColumnSettings.prixUnitaire" class="table-input text-center width-input" >
                                    <div *ngIf="item.designation" style="position: relative; display: inline-block; width: 100%;">
                                        <!-- Pour INVENTAIRE et BON TRANSFERT, afficher valeur_unitaire -->
                                        <input 
                                            *ngIf="documentType === 'INVENTAIRE' || documentType === 'BON TRANSFERT'"
                                            type="number" 
                                            class="form-control input-price" 
                                            [(ngModel)]="item.valeur_unitaire" 
                                            (input)="calculateTotal(i)"
                                            style="padding-right: 30px; text-align: center;">
                                        <!-- Pour FACTURE FOURNISSEUR : Prix d'achat (éditable) + Valeur unitaire (moyenne, affichée) -->
                                        <ng-container *ngIf="documentType === 'FACTURE FOURNISSEUR'">
                                            <input 
                                                type="number" 
                                                class="form-control input-price" 
                                                [(ngModel)]="item.priceHT" 
                                                (input)="calculateTotal(i)"
                                                style="padding-right: 30px; text-align: center;"
                                                placeholder="Prix d'achat">

                                        </ng-container>
                                        <!-- Pour les autres types (vente, etc.), afficher priceHT -->
                                        <input 
                                            *ngIf="documentType !== 'INVENTAIRE' && documentType !== 'BON TRANSFERT' && documentType !== 'FACTURE FOURNISSEUR'"
                                            type="number" 
                                            class="form-control input-price" 
                                            [(ngModel)]="item.priceHT" 
                                            (input)="calculateTotal(i)"
                                            style="padding-right: 30px; text-align: center;">
                                        <button type="button" class="button-inc-price" (click)="incrementPrice(i)">
                                            <span data-feather="chevron-up" class="flech"></span>
                                        </button>
                                        <button type="button" class="button-dec-price" (click)="decrementPrice(i)">
                                            <span data-feather="chevron-down"></span>
                                        </button>
                                    </div>
                                </td>

                                <td *ngIf="documentColumnSettings.remise" class="table-input text-center"
                                style="min-width: 60px">
                                    <input *ngIf="item.designation" type="number" class="form-control " [(ngModel)]="item.remise" (input)="calculateTotal(i)" min="0" max="100">
                                </td>

                                <td *ngIf="documentColumnSettings.tva" class="table-input text-center">
                                    <select *ngIf="item.designation" class="form-control" [(ngModel)]="item.tva" (change)="calculateTotal(i)"
                                    style="min-width: 80px">
                                        <option value="0">0%</option>
                                        <option *ngFor="let tva of tvaRates" [value]="tva.valeur">{{ tva.valeur }}%</option>
                                    </select>
                                </td>

                                <td *ngIf="documentColumnSettings.afficherMontantsTTC && documentType !== 'INVENTAIRE' && documentType !== 'BON TRANSFERT'"
                                    class="table-input" style="min-width: 60px">
                                    <span *ngIf="item.designation">{{ getLineTotalTTC(item) | number:'1.3-3' }} TND</span>
                                </td>
                                <td class="table-input text-end fw-bold" style="padding-top: 24px">
                                    <span *ngIf="item.designation">{{ getLineTotalHT(item) | number:'1.3-3' }} TND</span>
                                </td>



                                <td class="position-sticky end-0 table-input"
                                    style="z-index: 10; width: 140px">
                                    <div class="d-flex align-items-center justify-content-end" style="gap: 8px;">
                                        <img *ngIf="item.designation" [src]="img + 'discount-2.png'" class="text-primary" title="Marge" style="cursor: pointer;" (click)="openmargeModal(i)" >
                                        <a (click)="removeItem(i)"  title="Supprimer" style="color: rgba(203, 58, 58, 1); cursor: pointer;">
                                        <i data-feather="trash-2" class="feather-16" size="22"></i>
                                    </a>
                                    </div>
                                </td>
                            </tr>
                            
                        </ng-container>

                        <!-- Lignes texte / séparateur / sous-total -->
                        <ng-container *ngSwitchCase="'text'">
                            <tr 
                                draggable="true"
                                (dragstart)="onDragStart($event, i)"
                                (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event, i)"
                                (drop)="onDrop($event, i)"
                                (dragenter)="onDragEnter($event)"
                                [class.dragging]="draggedIndex === i"
                                style="cursor: move;">
                                <td [attr.colspan]="getColspan()" class="table-input">
                                    <textarea [(ngModel)]="item.content" class="form-control" rows="2"></textarea>
                                </td>
                                <td class="position-sticky end-0 table-input" style="z-index: 10; width: 100px">
                                    <div class="d-flex align-items-center justify-content-end">
                                        <a (click)="removeItem(i)" style="color: rgba(203, 58, 58, 1); cursor: pointer;" ><i data-feather="trash-2" size="22"></i></a>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>

                        <ng-container *ngSwitchCase="'heading'">
                            <tr 
                                draggable="true"
                                (dragstart)="onDragStart($event, i)"
                                (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event, i)"
                                (drop)="onDrop($event, i)"
                                (dragenter)="onDragEnter($event)"
                                [class.dragging]="draggedIndex === i"
                                style="cursor: move;">
                                <td [attr.colspan]="getColspan()" class="table-input">
                                    <input
                                            [(ngModel)]="item.content"
                                            type="text"
                                            class="form-control"
                                            placeholder="Ajoutez une rubrique"
                                            style="border: 1px solid #ced4da; width: 100%; margin: 0 auto; text-align: start;"
                                    />
                                </td>
                                <td class="position-sticky end-0 table-input" style="z-index: 10; width: 100px">
                                    <div class="d-flex align-items-center justify-content-end">
                                        <a (click)="removeItem(i)" style="color: rgba(203, 58, 58, 1); cursor: pointer;">
                                        <span data-feather="trash-2" [size]="22"></span>
                                    </a>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <!-- Separator Row -->
                        <ng-container *ngSwitchCase="'separator'">
                            <tr 
                                draggable="true"
                                (dragstart)="onDragStart($event, i)"
                                (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event, i)"
                                (drop)="onDrop($event, i)"
                                (dragenter)="onDragEnter($event)"
                                [class.dragging]="draggedIndex === i"
                                style="cursor: move;">
                                <td [attr.colspan]="getColspan()" class="table-input">
                                    <div style="border-top: 2px solid #134ADB; width: 100%; margin: 4px 0;"></div>
                                </td>
                                <td class="position-sticky end-0 table-input" style="z-index: 10; width: 100px">
                                    <div class="d-flex align-items-center justify-content-end">
                                        <a (click)="removeItem(i)" style="color: rgba(203, 58, 58, 1); cursor: pointer;">
                                        <span data-feather="trash-2" [size]="22" ></span>
                                    </a>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <!-- Subtotal Row -->
                        <ng-container *ngSwitchCase="'subtotal'">
                            <tr 
                                draggable="true"
                                (dragstart)="onDragStart($event, i)"
                                (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event, i)"
                                (drop)="onDrop($event, i)"
                                (dragenter)="onDragEnter($event)"
                                [class.dragging]="draggedIndex === i"
                                style="cursor: move;">
                                <td [attr.colspan]="getColspan()-1" class="table-input" ></td>
                                <td  class="table-input  text-center">
                                    <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.7); text-align: center;">
                                        Sous-total
                                    </div>
                                    <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.9); text-align: center;">
                                        {{item.subTotal | number:'1.3-3'}} TND
                                    </div>
                                </td>
                                <td class="position-sticky end-0 table-input" style="z-index: 10; width: 100px">
                                    <div class="d-flex align-items-center justify-content-end" style="gap: 8px;">
                                        <img [src]="img + 'discount-2.png'" class="text-primary"
                                             title="Marge" style="cursor: pointer;" (click)="openmargeModal(i)" >
                                        <a (click)="removeItem(i)" style="color: rgba(203, 58, 58, 1); cursor: pointer;">
                                        <span data-feather="trash-2" [size]="22"></span>
                                    </a>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>




                    </ng-container>
                </ng-container>
                </tbody>
            </table>

            <div class="d-flex align-items-center flex-wrap gap-2" style="padding-top: 24px">
                <button type="button" class="btn btn-outline-primary" style="margin-right: 8px"
                        (click)="triggerDocumentProductImport()"
                        [disabled]="isLoadingProducts"
                        title="Importer des lignes produit depuis un fichier Excel (même colonnes que l’import Produits)">
                    Importation (XLSX)
                </button>
                <input #documentProductImportInput type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       (change)="onDocumentProductImportFileSelected($event)" hidden />
                <div ngbDropdown class="btn-group">
                    <button type="button" class="btn btn-primary" (click)="addItem('product')" rippleEffect><p >Ajouter Un Produit</p></button>
                    <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle-split" rippleEffect>
                        <span class="sr-only"><p style="margin: 4px 10px;">Toggle Dropdown</p></span>
                    </button>
                    <div ngbDropdownMenu>
                      <!--  <a ngbDropdownItem href="javascript:void(0)" (click)="addItem('code_bar')">Scanner des codes à barres</a> -->
                        <a ngbDropdownItem href="javascript:void(0)" (click)="addItem('text')">Ajouter un texte</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="addItem('heading')">Ajouter une rubrique</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="addItem('separator')">Ajouter un séparateur</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="addItem('subtotal')">Ajouter un sous-total</a>
                    </div>
                </div>

            </div>

            <div class="d-flex align-items-start justify-content-between mt-4" *ngIf="showVenteAchatTotalsSection()">
                <div class="products-section" style="position: relative; left: 50%; transform: translateX(-80%);">
                    <table class="products-table table-bordered" style="width: 400px;">
                        <thead style="height: 56px; background-color: rgba(19, 74, 211, 0.16);">
                        <tr>
                            <th>TVA</th>
                            <th>BASE</th>
                            <th>MONTANT</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let tva of tvaSummary">
                            <td class="table-input">{{tva.rate}}%</td>
                            <td class="table-input">{{tva.base | number:'1.3-3'}} TND</td>
                            <td class="table-input">{{tva.amount | number:'1.3-3'}} TND</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div *ngIf="documentColumnSettings.afficherMontantTotal" style="position: relative; width: 100%; max-width: 400px; margin-left: auto;">
                    <table class="table table-borderless text-start rounded totals-table"
                           style="width: 100%; border: 1px solid rgba(47, 43, 61, 0.14); border-top: 1px solid rgba(19, 74, 211, 1); border-collapse: collapse; border-radius: 8px; overflow: visible">
                        <tbody>
                        <tr class="table-row">
                            <td>Total HT</td>
                            <td>{{totals.totalHT | number:'1.3-3'}} TND</td>
                        </tr>
                        <tr class="table-row" *ngFor="let line of totals.taxesAfterHT">
                            <td>{{ line.label }}</td>
                            <td>{{ line.amount | number:'1.3-3' }} TND</td>
                        </tr>
                        <tr class="table-row">
                            <td>Total TVA</td>
                            <td>{{totals.totalTVA | number:'1.3-3'}} TND</td>
                        </tr>
                        <tr class="table-row">
                            <td>Total TTC</td>
                            <td>{{totals.totalTTC | number:'1.3-3'}} TND</td>
                        </tr>
                        <tr class="table-row" *ngFor="let line of totals.taxesAfterTTC">
                            <td>{{ line.label }}</td>
                            <td>{{ line.amount | number:'1.3-3' }} TND</td>
                        </tr>
                        <!-- Taxes sur la TVA (paramètre taxes, ex. timbre fiscal) : une ligne par taxe active -->
                        <tr class="table-row" *ngFor="let line of totals.taxesAfterTimbre">
                            <td>{{ line.label }}</td>
                            <td>{{ line.amount | number:'1.3-3' }} TND</td>
                        </tr>
                        <tr class="fw-bold">
                            <td>Net à payer</td>
                            <td>{{totals.netAPayer | number:'1.3-3'}} TND</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="footer-info d-flex justify-content-between" *ngIf="documentColumnSettings.afficherCoordonneesClients ">
            <div class="company-info" *ngIf="showFooterEntrepriseBlock()">
                <p style="font-size: 15px; font-weight: 600;">Entreprise</p>
                <p class="information">{{ entreprise.nom }}</p>
                <p class="information">{{ entreprise.adresse }}</p>
                <p class="information">{{ entreprise.ville }} {{ entreprise.pays }}</p>
                <p class="information">Matricule fiscal: {{ entreprise.matricule_fiscal }}</p>
            </div>
            <div class="coordinates" *ngIf="showFooterCoordonneesBlock()">
                <p style="font-size: 15px; font-weight: 600;">Coordonnées</p>
                <p class="information">{{ stationFooterCoordName }}</p>
                <p class="information">{{ stationFooterCoordEmail }}</p>
                <p class="information">{{ stationFooterCoordPhones }}</p>
            </div>
            <div class="bank-info d-flex align-items-start flex-wrap gap-3">
                <div class="bank-info-text" style="min-width: 240px; flex: 1;">
                    <p style="font-size: 15px; font-weight: 600;">Coordonnées bancaires</p>
                    <ng-select
                        *ngIf="canSelectDocumentBanque()"
                        [items]="availableBanques"
                        bindValue="id"
                        [(ngModel)]="selectedBanqueId"
                        (ngModelChange)="onSelectedBanqueChange($event)"
                        [clearable]="false"
                        [searchable]="true"
                        placeholder="Choisir un compte bancaire"
                        class="ng-select-custom text-muted mb-1"
                        style="max-width: 360px;"
                    >
                        <ng-template ng-label-tmp let-item="item">
                            {{ banqueOptionLabel(item) }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <div class="d-flex flex-column">
                                <span>{{ item.nom || item.designation || 'Compte' }}</span>
                                <small class="text-muted">{{ item.rib }}</small>
                            </div>
                        </ng-template>
                    </ng-select>
                    <ng-container *ngIf="!canSelectDocumentBanque()">
                        <p class="information">{{ banque.nom_banque }}</p>
                    </ng-container>
                    <p class="information">{{ banque.rib }}</p>
                    <p class="information text-muted small mb-0" *ngIf="!availableBanques.length && (!banque.rib || banque.rib === '--')">
                        Aucun compte bancaire — ajoutez-en dans Paramètres.
                    </p>
                </div>
            </div>
            <div class="footer-document-cachet" *ngIf="documentCachetUrl">
                <p style="font-size: 15px; font-weight: 600;">Cachet et Signature</p>
                <img [src]="documentCachetUrl" alt="Cachet" class="footer-document-cachet__img" />
            </div>
        </div>
    </div>
</div>

<!-- Email Compose Component -->
<app-email-compose
    #emailModal
    [documentId]="documentId"
    [reference]="documentReference || 'N/A'"
    [date]="documentDate || ''"
    [total]="getFormattedTotal()">
</app-email-compose>
